<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss"></style>
<script>
import "@/assets/scss/app.scss";
import "@/assets/updata.config.js";

export default {
  name: "App",
  data() {
    return {
      imageOnerror: "/img/image_onerror.jpg"
    };
  },
  methods: {},
  mounted() {
    window.addEventListener("offline", () => {
      this.$bvToast.toast(
        "部分功能將無法使用，請檢查您的網路連線，並再試一次",
        {
          title: `您現在處於離線狀態`,
          toaster: "b-toaster-top-center",
          solid: true,
          appendToast: false,
          variant: "manage_main"
        }
      );
    });
    this.$nextTick(() => {
      var imgList = document.querySelectorAll("img");
      Array.prototype.forEach.call(imgList, item => {
        item.onerror = () => {
          item.src = this.imageOnerror;
        };
      });
    });
    if ("serviceWorker" in navigator) {
      // window load後才執行，以免增加頁面讀取的時間
      window.addEventListener("load", function() {
        // 建立sw.js
        navigator.serviceWorker
          .register("/sw.js")
          .then(function(reg) {
            console.log(reg.scope); // 看這支sw.js執行的範圍
          })
          // 註冊失敗
          .catch(function(err) {
            console.log("error: ", err);
          });

        // 附上刪除sw.js的寫法
        // navigator.serviceWorker.getRegistrations().then(function(reg) {
        //   for (var reg of reg) {
        //     reg.unregister();
        //   }
        // });
      });
    }
  }
};
</script>
